<template>
  <section role="region" class="our-system-section" ref="ourSystemSection">
    <div class="interface" style="transition-duration: 0.5s !important" v-show="showColumns"
      :class="makeFade ? 'show' : ''">
      <img src="@/assets/images/business/interface.png" alt="Imagem de interface do MeLembre" loading="lazy" />
      <TheSecondHead titleText="Interface de parametrização"
        subtitleText="Nossa interface de parametrização permite que sua empresa analise o comportamento dos clientes e a eficácia das estratégias utilizadas. Sendo possível, através das informações, realizar mudanças que causem impacto positivo e maior eficiência." />
    </div>
    <div class="dashboard" style="transition-duration: 1s !important" v-show="showColumns"
      :class="makeFade ? 'show' : ''">
      <img src="@/assets/images/business/dashboard.png" alt="Imagem de interface do MeLembre" loading="lazy" />
      <TheSecondHead titleText="Dashboard para acompanhamento em tempo real"
        subtitleText="Tenha acesso a informações, indicadores e métricas em tempo real. Tome decisões com base em dados e tenha muito mais assertividade em seus processos." />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'

const showColumns = ref<Boolean>(false);
const makeFade = ref<Boolean>(false);
const ourSystemSection = ref<any>(null);

const ourSystemWatcher = () => {
  var section = ourSystemSection.value;

  if ((window.scrollY + section.offsetHeight) >= section.offsetTop) {
    setTimeout(() => {
      makeFade.value = true;
    }, 100);
    window.removeEventListener('scroll', ourSystemWatcher);
  }
}

onMounted(() => {
  showColumns.value = true;
  window.addEventListener('scroll', ourSystemWatcher, {passive: true});
  ourSystemWatcher();
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', ourSystemWatcher);
})
</script>

<style lang="scss">
.our-system-section {
  padding: 40px 9px 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 40px;

  .headline {
    .title {
      margin: 36px 0px 20px;
      font-size: 40px;
      line-height: 110%;
    }
  }

  @media screen and (min-width: 834px) and (max-width: 959px) {
    padding: 68px 32px;
  }

  @media screen and (min-width: 960px) and (max-width: 1199px) {
    padding: 68px 0px;
    max-width: 766px;
  }

  @media screen and (min-width: 834px) {
    flex-direction: row;
    column-gap: 90px;
    justify-content: flex-start;
    align-items: flex-start;

    .interface {
      width: 306px;
    }

    .dashboard {
      width: 330px;
    }
  }

  @media screen and (min-width: 960px) {
    margin: 0 auto;

  }

  @media screen and (min-width: 1200px) {
    padding: 68px 0px 45px;
    column-gap: 224px;
    max-width: 861px;

  }

  // Animação de aparecer
  .interface,
  .dashboard {
    opacity: 0;
    -webkit-transform: translateY(245px);
    transform: translateY(245px);
  }

  .show {
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
    opacity: 1;
  }

  // Fim animação de aparecer
}
</style>